import React from 'react';

export const Clients_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>CLIENTES</span>,
  },
];

export const Clients_Text = [
  {
    textSize: '1rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    textMobile: '0.625rem',
    renderContent: () => (
      <span>
        Aviso: Todas las marcas registradas, nombres comerciales y logotipos
        presentados en este sitio son propiedad exclusiva de sus respectivos
        dueños.
        <br />
        Su uso aquí es sólo para fines de referencia e información y no implica
        ningún tipo de endorsamiento, afiliación o patrocinio.
      </span>
    ),
  },
];
